import { render, staticRenderFns } from "./ModalReviewAudition.vue?vue&type=template&id=c24ed0e8&"
import script from "./ModalReviewAudition.vue?vue&type=script&lang=js&"
export * from "./ModalReviewAudition.vue?vue&type=script&lang=js&"
import style0 from "./ModalReviewAudition.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports